import ViewDetails from "../../utils/utilities/ViewDetails";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import WorkHistoryRoundedIcon from '@mui/icons-material/WorkHistoryRounded';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import ManageHistoryRoundedIcon from '@mui/icons-material/ManageHistoryRounded';

// Tabs
import DetailsTab from "./Tabs/Details";
import ServiceHistoryTab from "./Tabs/ServiceHistory";
import InvoiceTab from "./Tabs/Invoice";
import AccountingTab from "./Tabs/Accounting";
import BillTab from "./Tabs/Bill";

import useAuth from "../../hooks/useAuth";


  const tabContent = [
    {panel: "details", content: <DetailsTab />},
    {panel: "service_history", content: <ServiceHistoryTab />},
    {panel: "invoice", content: <InvoiceTab />},
    {panel: "bill", content: <BillTab />},
    {panel: "accounting", content: <AccountingTab />},
  ]

const ViewInventory = () => {

  const { ability } = useAuth();

  const tabs = [
    {label: "Details", icon: <ReceiptLongRoundedIcon fontSize="small" />},
    {label: "Service History", icon: <ManageHistoryRoundedIcon fontSize="small" />},
    {label: "Invoice", icon: <AccountBalanceRoundedIcon fontSize="small" />, showTab: (data) => data?.status === "sold"},
    {label: "Bill", icon: <ReceiptLongRoundedIcon fontSize="small" />, showTab: (data) => data?.status === "sold"},
    {label: "Accounting", icon: <MonetizationOnRoundedIcon fontSize="small" />, showTab: (data) => data?.status === "sold" && ability.can('read', 'Accounting')},
  ];

  return (
    <ViewDetails title="Inventory" identifier="wig_id" tabs={tabs} tabContent={tabContent} isProfile={false} url="inventory">

    </ViewDetails>
  )
};

export default ViewInventory;